import { Typography, makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
  },
  title: {
    fontSize: '0.9rem',
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary,
  },
  content: {
    maxHeight: '120px',
    overflowY: 'auto',
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
    lineHeight: 1.8,
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(0.5),
    '&:before': {
      content: '"•"',
      marginRight: theme.spacing(1),
      color: theme.palette.text.secondary,
    },
  },
}));

interface SelectedEntity {
  id: React.Key;
  name: string;
}

interface SelectedEntitiesListProps {
  title: string;
  entities: SelectedEntity[];
}

export const SelectedEntitiesList: React.FC<SelectedEntitiesListProps> = ({ title, entities }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Typography variant="h4" className={classes.title}>
        {title}
      </Typography>
      <div className={classes.content}>
        {entities.map((entity) => (
          <Typography variant="body2" key={entity.id} className={classes.item}>
            {entity.name}
          </Typography>
        ))}
      </div>
    </div>
  );
};
